export default __webpack_public_path__ + "static/media/sounds/TRO_Mic_Access.mp3";